import 'normalize.css';
import 'font-awesome/css/font-awesome.css';

import './app.scss';

import '../../../common/assets/scss/common.scss';
import '../../../common/assets/scss/ods.scss';
/**
 * This component just imports all the main stylesheets and wraps all its children inside an
 * specific element so they can all inherit the styles.
 * @ngesdoc component
 * @ngname app
 * @ngmodule root
 * @ngtransclude
 */
export default {
  transclude: true,
  template: `
    <div class="app">
      <div class="app_children" ng-transclude></div>
    </div>
  `,
};
